import { httpRequest } from "@/lib";
import { User } from "@/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export interface RequestResetPasswordResponse {
  message: string;
  data: User;
}

export interface ResetPassword {
  email: string;
  token: string;
  password: string;
}

async function resetPassword(
  request: ResetPassword
): Promise<RequestResetPasswordResponse> {
  const response = await httpRequest.post<RequestResetPasswordResponse>(
    `/password/reset`,
    request
  );
  return response.data;
}

export function useResetPasswordMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: resetPassword,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"] });
    },
  });
}
